import { selector  } from "recoil";
import { userAuthDetail } from "../atoms/userDetailAtom"

export const getUserRydeSendToken = selector({
    key: "rydeSendToken",
    get: ({ get }) => {
      const userAuthDetails = get(userAuthDetail);
      return userAuthDetails.rydeSendToken
    },
});

export const userLoggedIn = selector({
  key: "userLoginStatus",
  get: ({ get }) => {
    const userAuthDetails = get(userAuthDetail);
    return userAuthDetails.rydeSendToken !== ""
  },
});
